import * as React from 'react';
import Layout from './Components/Layout';
import { Routes } from './Routes';
import 'jquery/dist/jquery.min.js'
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@progress/kendo-theme-bootstrap/dist/all.css';
import { initilizeUserInfo } from 'service/userService'
import { Loader } from '@progress/kendo-react-indicators';
import { msalInstance } from '.';
import { withRouter } from 'react-router-dom';
import UnauthorizedAccess from 'Components/Authentication/UnauthorizedAccess'
import { registerInactivityService, unregisterInactivityService } from 'service/inactivityService'
/**
 * Sandeep: Initilize user info and set the cache for the user by utilizing the received access token.
 * Loader types: ["pulsing", "infinite-spinner", "converging-spinner"];
 */
class App extends React.Component {

    constructor(props: any) {
        super(props)
    }



    componentDidUpdate(prevProps) {
        let  location  = this.props;
        // Only track changes if the location (route) has actually changed
        if (location !== prevProps.location) {
            document.body.classList.remove("opportunity-dashboard");
        }
        registerInactivityService();
    }

    componentWillUnmount() {
        unregisterInactivityService();
    }

    /**
     * State of the component
     */
    state = {
        initilized: false,
        authorized: true
    }

    /**
     * Sandeep: Get and cache user information in local storage for UI use.
     * we are ensuring all keys to be encrypted while getting the information.
     */
    componentDidMount = async () => {
        const { location } = this.props;
        await initilizeUserInfo(this.initRender);
    }

    /**
     * Sandeep: Callback method to render the UI after the token is received and set to cache.
     */
    initRender = (status: string) => {
        if (status == '200')
            this.setState({ initilized: true });
        else if (status == '401')
            this.setState({ authorized: false });
    }

    //SS: Log out unauthorize user and display prompt.
    logOutUnauthorizedUser = () => {
        msalInstance.logout();
    }

    /**
     * Render the UI.
     * @returns
     */
    render() {
        const url = new URL(window.location.href);
        const params = url.searchParams;
        const domain: any = params.get('source') !== null ? params.get('source') : null;
        return <>
            {
                this.state.initilized ?
                    <Layout ><Routes /></Layout> :
                    //<Loader size="large" type="converging-spinner" style={{ transform: "translate(-50%, -50%)", position: 'absolute', top: '50%', padding: '10px', left: '50%' }} />
                    this.state.authorized ? <div className="loading d-flex justify-content-center align-items-center">
                        <span className="loader3">Trailboss</span>
                    </div> :
                        <UnauthorizedAccess />
            }

        </>
    }
};
export default withRouter(App);
